import { AxiosResponse } from "axios"
import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"

/**
 * システム関連に対するAPIリクエスト用サービス
 *
 * @export
 * @class SystemService
 * @extends {ConnectApi}
 */
export default class SystemService extends ConnectApi {
  /**
   * 業務日付取得
   *
   * @memberof SyaryoService
   */
  get = async () => {
    try {
      const res: AxiosResponse<TApiResponse<string>> = await this.getInner(
        `/system/gyomudy`
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 年度取得
   * @returns 年度
   */
  getNendo = async () => {
    try {
      const res: AxiosResponse<TApiResponse<number>> = await this.getInner(
        `/system/nendo`
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
